/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MentionNotificationResponse
 */
export interface MentionNotificationResponse {
  /**
   *
   * @type {string}
   * @memberof MentionNotificationResponse
   */
  message: string;
  /**
   *
   * @type {boolean}
   * @memberof MentionNotificationResponse
   */
  inAppNotification: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MentionNotificationResponse
   */
  emailSent: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MentionNotificationResponse
   */
  emailEnabled: boolean;
  /**
   *
   * @type {string}
   * @memberof MentionNotificationResponse
   */
  emailError?: string;
}

/**
 * Check if a given object implements the MentionNotificationResponse interface.
 */
export function instanceOfMentionNotificationResponse(value: object): value is MentionNotificationResponse {
  if (!('message' in value) || value['message'] === undefined) return false;
  if (!('inAppNotification' in value) || value['inAppNotification'] === undefined) return false;
  if (!('emailSent' in value) || value['emailSent'] === undefined) return false;
  if (!('emailEnabled' in value) || value['emailEnabled'] === undefined) return false;
  return true;
}

export function MentionNotificationResponseFromJSON(json: any): MentionNotificationResponse {
  return MentionNotificationResponseFromJSONTyped(json, false);
}

export function MentionNotificationResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MentionNotificationResponse {
  if (json == null) {
    return json;
  }
  return {
    message: json['message'],
    inAppNotification: json['in_app_notification'],
    emailSent: json['email_sent'],
    emailEnabled: json['email_enabled'],
    emailError: json['email_error'] == null ? undefined : json['email_error'],
  };
}

export function MentionNotificationResponseToJSON(value?: MentionNotificationResponse | null): any {
  if (value == null) {
    return value;
  }
  return {
    message: value['message'],
    in_app_notification: value['inAppNotification'],
    email_sent: value['emailSent'],
    email_enabled: value['emailEnabled'],
    email_error: value['emailError'],
  };
}
